export const formBuilderCustomTranslations = {
  "data-locale": {
    uploading: "Uploading",
    remove: "Remove file",
    invalid: "This file cannot be uploaded",
    failed: "The file failed to upload"
  }
};
